<button (click)="updateSort()">
  <ng-content></ng-content>
  <img *ngIf="sortOrder === null" src="/assets/icons/sort/sort-by.svg" alt="Sort by this column">
  <img *ngIf="sortOrder === 'Ascending'" src="/assets/icons/sort/sort-by-asc.svg" alt="Sorted ascending">
  <img *ngIf="sortOrder === 'Descending'" src="/assets/icons/sort/sort-by-desc.svg" alt="Sorted descending">
</button>